import React from "react";
import PropTypes from "prop-types";
import Analytics from "analytics/util/Analytics";

import { getProfileUrl } from "apps/discovery/util/helpers";

const UserWrapper = (props) => {
	const profileUrl = getProfileUrl(props);

	const _handleClick = (e) => {
		Analytics.logUIEvent(Analytics.eventNames.discoveryClickedProfile, {
			data: {
				section: props.sectionId,
				section_index: props.sectionOrder.indexOf(props.sectionId),
				userid: props.user.userid,
				profile_Index: props.index,
			},
		});

		// don't proceed if they are opening this person in a new tab
		if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();
		props.visitUser(profileUrl);
	};

	return (
		<a
			href={profileUrl}
			onClick={_handleClick}
			className={props.className}
			data-profile-popover
		>
			{props.children}
		</a>
	);
};

UserWrapper.propTypes = {
	user: PropTypes.object.isRequired,
	sectionId: PropTypes.string.isRequired,
	sectionOrder: PropTypes.array.isRequired,
	visitUser: PropTypes.func.isRequired,
	index: PropTypes.number,
	className: PropTypes.string,
	children: PropTypes.node,
};

export default UserWrapper;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/user/UserWrapper.jsx